import { BodyTextL } from 'global-styles';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { ProductCommonTitleEn, ProductCommonTitleKR } from '../ProductCommons';
import { FeatureItem, ProductFeaturesContainer } from '../ProductFeatures';
import { isMobileOnly } from 'react-device-detect';
import { useAutoPlayVideoWhenVisible } from 'hooks';
import { ItemTitle } from '../Atoms/Feature';
import AvifProductProvide from './AvifProductProvide';
import AvifSQTestCondition from './AvifSQTestCondition';

interface Props {
  locale: string;
  featureItems: {
    featureItems: FeatureItem[];
  };
}

const AvifProductFeatures = ({ locale, featureItems }: Props) => {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  const setRefs = useAutoPlayVideoWhenVisible();

  // mobile, desktop 비디오 결정
  useEffect(() => {
    if (isMobileOnly) setIsMobile(true);
    else setIsMobile(false);
  }, []);

  return (
    <AvifProductFeaturesContainer>
      <div className="feat-title-wrapper">
        {locale === 'en' ? (
          <ProductCommonTitleEn>Product features</ProductCommonTitleEn>
        ) : (
          <ProductCommonTitleKR>제품 특징</ProductCommonTitleKR>
        )}
      </div>

      {featureItems.featureItems.map(featureItem => (
        <div className="feat-unit-wrapper" key={featureItem.featureName['en']}>
          <div className="n-wrapper">
            <ItemTitle>{featureItem.featureName[locale]}</ItemTitle>
          </div>

          {isMobile !== undefined && featureItem.vids.length !== 0 && (
            <div className="avif-vid-wrapper">
              <video
                ref={setRefs}
                src={isMobile ? featureItem.vids[0] : featureItem.vids[1]}
                className="avif-vid"
                playsInline
                controls
                muted
                loop
              />
            </div>
          )}

          {/* description */}
          {featureItem.featureText[locale].map(t => (
            <BodyTextL className="t" key={t}>
              <span>{t}</span>
            </BodyTextL>
          ))}
        </div>
      ))}

      <AvifProductProvide isVisible locale={locale} />
      <AvifSQTestCondition />
    </AvifProductFeaturesContainer>
  );
};

export default AvifProductFeatures;

const AvifProductFeaturesContainer = styled(ProductFeaturesContainer)`
  padding-bottom: 96px;
  .avif-vid-wrapper {
    width: 100%;
    position: relative;
    padding-top: 56.25%;
  }
  .avif-vid {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
  }
`;
